import { Radio } from "antd";
import styled, { css } from "styled-components";

export const CustomRadioStyle = css`
  &.renderbus-ui--radio {
    .ant-radio {
      .ant-radio-inner {
        background: transparent;
        border-color: rgba(255, 255, 255, 0.2);

        &::after {
          background-color: var(--main-color);
        }
      }
      + span {
        display: flex;
        align-items: center;
      }
    }

    .ant-radio.ant-radio-checked {
      .ant-radio-inner {
        border-color: var(--main-color);
      }
    }

    &.ant-radio-wrapper-disabled {
      span {
        color: rgba(255, 255, 255, 0.35);
      }

      .ant-radio-disabled {
        .ant-radio-inner {
          border-color: rgba(255, 255, 255, 0.35);
          &::after {
            background-color: rgba(255, 255, 255, 0.35);
          }
        }
      }
    }
    &.ant-radio-button-wrapper {
      background: unset;
      color: ${(p) => p.theme["color-text-3"]};
      border-color: #595b61;
      ::before {
        background-color: #595b61;
      }
    }
    &.ant-radio-button-wrapper-checked {
      border-color: ${(p) => p.theme["theme-5"]};
      color: ${(p) => p.theme["theme-5"]};
      ::before {
        background-color: ${(p) => p.theme["theme-5"]};
      }
    }
    &.ant-radio-button-wrapper:first-child {
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
    &.ant-radio-button-wrapper:last-child {
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  }
`;
export const StyledRadio = styled(Radio)`
  ${CustomRadioStyle};
`;
export const StyledRadioGroup = styled(StyledRadio.Group)`
  ${CustomRadioStyle};
`;
export const StyledRadioButton = styled(StyledRadio.Button)`
  ${CustomRadioStyle};
`;
